import { useParams } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useGetNetworkQuery, useUploadNetworkCoverMutation } from '@/core/services/network'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

import { getApiErrorMessage } from '@/utils/errors'

import NetworkCoverPhoto from '../components/NetworkCoverPhoto'

export default function NetworkCoverPhotoContainer() {
  const { networkId } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const authUser = useAppSelector(selectAuthUser)

  const { data: network } = useGetNetworkQuery(networkId ?? '', { skip: !networkId })
  const [uploadCover] = useUploadNetworkCoverMutation()

  return (
    <NetworkCoverPhoto
      disableUpload={network?.createdBy._id !== authUser?._id}
      onUpload={async (file) => {
        if (!networkId) return

        try {
          await uploadCover({ networkId, file }).unwrap()
        } catch (error) {
          enqueueSnackbar(getApiErrorMessage(error, t('notification.network.uploadCover.error')), { variant: 'error' })
        }
      }}
      url={network?.coverPhoto?.url}
    />
  )
}
